import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,{attrs:{"value":_vm.overlay,"opacity":_vm.opacity,"z-index":10}},[_c('div',{style:(_vm.style),attrs:{"id":"anim"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }